import React from 'react';
import { Reveal } from './Reveal';
import { painPoints } from '../data/painPoints';
export function PainPointsSection() {
  return <section aria-labelledby="painpoints-title" className="bg-brand-sand px-4 py-20 md:py-28" data-id="element-146" data-mp="2htbopmh5dzgg">
      <Reveal className="mx-auto max-w-content text-center" data-id="element-147" data-mp="2wpt3knojpw7r">
        <h2 id="painpoints-title" className="text-3xl font-extrabold tracking-tight text-brand-primary md:text-4xl" data-id="element-148" data-mp="2rpf3brt6rqka">
          🏃 Ti Riconosci in Queste Situazioni?
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-brand-gray" data-id="element-149" data-mp="30qmod86oyuwf">
          <strong className="font-bold text-brand-text" data-id="element-150" data-mp="30q3g6j6ufkvl">Non sei solo/a.</strong> La maggior parte degli insegnanti vive
          esattamente questo.
        </p>
        <div className="mt-12 grid gap-5 md:grid-cols-3" data-id="element-151" data-mp="3afwietl3inn6">
          {painPoints.map(({
          title,
          description
        }, index) => <article key={title} className="flex flex-col rounded-[18px] bg-brand-alt p-6 text-left shadow-sm md:p-7" data-id="element-152" data-mp="3oh0j56gnv7up" data-mpi={index}>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-brand-primary font-display text-sm font-bold text-white" data-id="element-153" data-mp="sv1dk3qx3p1s">
                {index + 1}
              </span>
              <h3 className="mt-5 text-lg font-bold leading-snug text-brand-primary" data-id="element-154" data-mp="11vg5hlye02e9">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-brand-gray" data-id="element-155" data-mp="16uj8z1ypy0k4">{description}</p>
            </article>)}
        </div>
        <p className="mt-12 font-display text-2xl font-bold italic text-brand-accent" data-id="element-156" data-mp="1bskstp3yy3wn">
          E meriti molto di più di questo.
        </p>
      </Reveal>
    </section>;
}